export default __webpack_public_path__ + "static/media/man.07579131.png";